package com.patronat.top.dto.venues

import kotlinx.serialization.Serializable

@Serializable
data class VenueServices(
    val servicesList: List<ServiceItem> = emptyList(),
    val priceListMedia: VenueMediaRef? = null,
    val priceListUrl: String? = null // URL to PDF file
)

@Serializable
data class ServiceItem(
    val name: String,
    val description: String? = null,
    val price: Double,
    val currency: String = "UAH"
)
